import { render, staticRenderFns } from "./NbIotAssetCreated.vue?vue&type=template&id=53c5e40a&scoped=true&"
import script from "./NbIotAssetCreated.vue?vue&type=script&lang=js&"
export * from "./NbIotAssetCreated.vue?vue&type=script&lang=js&"
import style0 from "./NbIotAssetCreated.vue?vue&type=style&index=0&id=53c5e40a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5e40a",
  null
  
)

export default component.exports